import { render, staticRenderFns } from "./StockAmount.vue?vue&type=template&id=74ed4c4c&"
import script from "./StockAmount.vue?vue&type=script&lang=js&"
export * from "./StockAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports